function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5751_5239)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.0623 6.28394H3.93734C3.37355 6.28394 2.9165 6.76609 2.9165 7.36086V12.207C2.9165 12.8018 3.37355 13.2839 3.93734 13.2839H10.0623C10.6261 13.2839 11.0832 12.8018 11.0832 12.207V7.36086C11.0832 6.76609 10.6261 6.28394 10.0623 6.28394Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.0835 6.28393V3.9506C4.0835 3.17705 4.39079 2.43519 4.93777 1.88821C5.48475 1.34123 6.22661 1.03394 7.00016 1.03394C7.77371 1.03394 8.51558 1.34123 9.06256 1.88821C9.60954 2.43519 9.91683 3.17705 9.91683 3.9506V6.28393",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
function SvgClosedDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedDeals);
export default __webpack_public_path__ + "static/media/closed-deals.486ac19c.svg";
export { ForwardRef as ReactComponent };